/**
 * Used to group/identify the query by larger context in the cache
 */
export const QUERY_KEYS = {
  deals: 'deals',
  auth: 'auth',
  roundDocuments: 'roundDocuments',
  dealDocuments: 'dealDocuments',
  dealsByLeadingOrganisationsId: 'dealsByLeadingOrganisationsId',
  currencies: 'currencies',
  countries: 'countries',
  kycFlow: 'kyc-flow',
  kycFlowStakeholdersStep: 'kycFlowStakeholdersStep',
  kycFlowAddressStep: 'kycFlowAddressStep',
  kycFlowTaxInformationStep: 'kycFlowTaxInformationStep',
  kycFlowQuestionnaireStep: 'kycFlowQuestionnaireStep',
  kycFlowIndividualInfoStep: 'kycFlowIndividualInfoStep',
  kycFlowIdentityStep: 'kycFlowIdentityStep',
  kycFlowFundingSourcesStep: 'kycFlowFundingSourcesStep',
  kycFlowCompanyInfoStep: 'kycFlowCompanyInfoStep',
  kycFlowBankAccountStep: 'kycFlowBankAccountStep',
  kycQuestionnaire: 'kycQuestionnaire',
  kycAuditLogs: 'kycAuditLogs',
  kycCompletionReport: 'kycCompletionReport',
  manageDeal: 'manageDeal',
  getReceiptGenerationErrors: 'getReceiptGenerationErrors',
  getSubscriptionAgreementGenerationErrors: 'getSubscriptionAgreementGenerationErrors',
  geKycReminderErrors: 'geKycReminderErrors',
  geWireReminderErrors: 'geWireReminderErrors',
  organisationSubscribers: 'organisationSubscribers',
  asset: 'asset',
  round: 'round',
  dealAgents: 'dealAgents',
  stakeholdersStructureKycFlow: 'stakeholdersStructureKycFlow',
  kycs: 'kycs',
  ubo: 'ubo',
  stakeholder: 'stakeholder',
  screeening: 'screeening',
  kycReviews: 'kycReviews',
  allUbosStakeholdersFromOrganisation: 'allUbosStakeholdersFromOrganisation',
  authorisedSignersKycFlow: 'authorisedSignersKycFlow',
  authorisedSignersKycFlowSignersOnly: 'authorisedSignersKycFlowSignersOnly',
  organisations: 'organisations',
  organisation: 'organisation',
  allSubscribers: 'allSubscribers',
  allOrganisations: 'allOrganisations',
  searchOrganisations: 'searchOrganisations',
  searchUsers: 'searchUsers',
  singleDeal: 'singleDeal',
  singleDealType: 'singleDealType',
  singleDealWithInvestments: 'singleDealWithInvestments',
  investments: 'investments',
  hasAccessToPlatform: 'hasAccessToPlatform',
  hasInvestorsAlreadyInvestedInRound: 'hasInvestorsAlreadyInvestedInRound',
  leadingOrganisationsDeals: 'leadingOrganisationsDeals',
  marketPlaceDeals: 'marketPlaceDeals',
  dealStatus: 'dealStatus',
  profile: 'profile',
  users: 'users',
  account: 'account',
  organisationDocuments: 'organisationDocuments',
  stakeholders: 'stakeholders',
  usersOrganisations: 'userOrganisations',
  decodeInvitationToken: 'decodeInvitationToken',
  retrieveUserOrganisations: 'retrieveUserOrganisations',
  investmentWireDetails: 'investmentWireDetails',
  transaction: 'transaction',
  transactions: 'transactions',
  organisationsFromUser: 'organisationsFromUser',
  organisationContactEmails: 'organisationContactEmails',
  subscriptionAgreementSigners: 'subscriptionAgreementSigners',
  bankDetails: 'bankDetails',
  globalSearch: 'globalSearch',
  portfolioStatementValidation: 'portfolioStatementValidation',
  valuationHistory: 'valuationHistory',
  dealMetadata: 'dealMetadata',
  isinTradeHistory: 'isinTradeHistory',
} as const
